import React, { useMemo } from 'react'

import RouteLayout from '../../RouteLayout'
import { Buttons, Form, Table } from './Components'
import Spinner from '../../common/Spinner'
import { useSelector } from 'react-redux'


export default function GIA () {
  
  const { loader, form, data, report_params } = useSelector(state => state.reports.gia)
  const orgList = useSelector(state => state.reports.orgList.data)

  const organizations = useMemo(() => orgList.reduce((acc, item) => ({...acc, [item.idOrganization]: item.orgName}), {}), [orgList])
  const orgName = useMemo(() => organizations[report_params.org] || '', [report_params.org, organizations])
  
  return (
    <RouteLayout title={'Сведения о результатах сдачи ГИА (форма 1/СВУ)'}>
      <Form form={form}/>
      <Buttons
        visible={!!data}
        orgName={orgName}
      />
      {loader
        ? <Spinner />
        : <Table
            data={data}
            organizations={organizations}
            reportParams={report_params}
            orgName={orgName}
          />
      }
    </RouteLayout>
  )
}
